import { useState } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { PRINCIPLE_STEPS } from "../i18n/translations";

export function PrincipleChain() {
  const { lang, t } = useLanguage();
  const [active, setActive] = useState(0);
  const reduce = useReducedMotion();
  const step = PRINCIPLE_STEPS[active];

  return (
    <div data-testid="principle-chain">
      <div className="flex flex-wrap gap-2 mb-8" role="tablist" aria-label={t("principle.title")}>
        {PRINCIPLE_STEPS.map((s, i) => {
          const on = i === active;
          return (
            <button
              key={s.key}
              role="tab"
              aria-selected={on}
              onClick={() => setActive(i)}
              data-testid={`principle-step-${s.key}`}
              className={`group relative flex items-center gap-2 rounded-full border px-3.5 py-2 text-sm transition-all duration-200 ${
                on
                  ? "border-[#1E3A2B] bg-[#1E3A2B] text-[#FBFBF9]"
                  : "border-[#1A1F1C]/12 bg-white text-[#525B56] hover:border-[#1E3A2B]/40"
              }`}
            >
              <span className={`font-mono-label text-[10px] ${on ? "text-[#C27B2B]" : "text-[#5B655F]"}`}>
                {String(i + 1).padStart(2, "0")}
              </span>
              {lang === "sv" ? s.sv : s.en}
            </button>
          );
        })}
      </div>

      <motion.div
        key={step.key}
        initial={reduce ? false : { opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="rounded-2xl border border-[#1A1F1C]/10 bg-white p-6 sm:p-8"
        data-testid="principle-detail"
      >
        <div className="font-mono-label text-[10px] text-[#C27B2B] mb-2">
          {t("principle.label")} · {String(active + 1).padStart(2, "0")} / 10
        </div>
        <h3 className="font-heading text-xl sm:text-2xl font-semibold text-[#1A1F1C] mb-3">
          {lang === "sv" ? step.sv : step.en}
        </h3>
        <p className="text-base text-[#525B56] leading-relaxed max-w-2xl">
          {lang === "sv" ? step.dsv : step.den}
        </p>
      </motion.div>
      <p className="mt-3 font-mono-label text-[10px] text-[#5B655F]">{t("principle.clickHint")}</p>
    </div>
  );
}
